import Swiper from 'swiper/bundle';


let galleryMainOptions = {
    loop: true,
    slidesPerView: "auto",
    centeredSlides: true,
    speed: 600,
    effect: "coverflow",
    coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 90,
        modifier: 1,
        slideShadows: true,
    },
    pagination: {
        el: '.section_slider .swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 320px
        300: {
            // spaceBetween: -40,

        },
        // when window width is >= 768px
        768: {
            spaceBetween: 16,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 0,
                modifier: 1,
                slideShadows: true,
            },
        }
    }
};

let gallerySecondaryOptions = {
    // modules: [EffectFade],
    effect: 'fade',
    speed: 600,
    fadeEffect: {
        crossFade: true
    },
    loop: false,
    slidesPerView: 1,
};

(function ($) {
    
    let sliderMain = new Swiper(".swiper-gallery", galleryMainOptions);
    let sliderSecondary = new Swiper(".swiper-gallery-secondary", gallerySecondaryOptions);

    // Sync the second slider with the first slider
    sliderMain.on('slideChangeTransitionStart', function () {
        let activeSlide = document.querySelector('.swiper-gallery .swiper-slide-active');
        let activeIndex = activeSlide.getAttribute('data-swiper-slide-index');

        sliderSecondary.slideTo(activeIndex);
    });

    // Handle window resize with debounce
    let resizeTimeout;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            if (sliderMain) {
                sliderMain.destroy(true, true);
            }
            sliderMain = new Swiper(".swiper-gallery", galleryMainOptions);
            sliderMain.on('slideChangeTransitionStart', function () {
                let activeSlide = document.querySelector('.swiper-gallery .swiper-slide-active');
                let activeIndex = activeSlide.getAttribute('data-swiper-slide-index');
                sliderSecondary.slideTo(activeIndex);
            });
        }, 300);
    });

    // Update sliders after images load
    window.addEventListener('load', function () {
        sliderMain.update();
        sliderSecondary.update();
    });



})(jQuery);